export default "__VITE_ASSET__5a1bbe53__"